import React from 'react';
import TermsTemplate from './TermsTemplate';

export default function SellerTerms() {
  const content = `
    <h2>제1조 (목적)</h2>
    <p>본 약관은 클로젯(이하 "회사")이 운영하는 플랫폼에서 상품을 판매하고 콘텐츠를 업로드하는 판매자(이하 "셀러")와 회사 간의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.</p>

    <h2>제2조 (정의)</h2>
    <ol>
      <li>"셀러"란 본 약관에 동의하고 회사가 제공하는 플랫폼을 통하여 상품을 판매하고 관련 콘텐츠를 업로드하는 사업자를 말합니다.</li>
      <li>"상품"이란 셀러가 플랫폼에 등록하여 판매하는 모든 재화 또는 용역을 말합니다.</li>
      <li>"콘텐츠"란 셀러가 플랫폼에 업로드하는 이미지, 영상, 음원, 텍스트 등 모든 형태의 창작물을 말합니다.</li>
      <li>"릴스"란 셀러가 업로드하는 숏폼 형태의 패션 영상 콘텐츠를 말합니다.</li>
    </ol>

    <h2>제3조 (셀러 가입 및 심사)</h2>
    <p><strong>1.</strong> 셀러로 가입하고자 하는 자는 다음의 자격 요건을 충족하여야 합니다.</p>
    <ul>
      <li>가. 사업자등록증을 보유한 개인사업자 또는 법인사업자</li>
      <li>나. 통신판매업 신고를 완료한 사업자</li>
      <li>다. 만 19세 이상의 대한민국 국민 또는 외국인 사업자</li>
      <li>라. 관련 법령에 따라 패션 상품 판매에 결격사유가 없는 자</li>
    </ul>

    <p><strong>2.</strong> 회사는 셀러의 가입 신청에 대하여 다음 각 호의 사유가 있는 경우 승인을 거부하거나 보류할 수 있습니다.</p>
    <ul>
      <li>가. 제출한 정보에 허위, 누락 또는 오기가 있는 경우</li>
      <li>나. 과거 회원 자격을 상실한 이력이 있는 경우</li>
      <li>다. 관련 법령을 위반하거나 위반할 우려가 있는 경우</li>
      <li>라. 기타 회사가 합리적으로 필요하다고 인정하는 경우</li>
    </ul>

    <h2>제4조 (상품 등록)</h2>
    <p><strong>1.</strong> 셀러는 자신이 정당한 권리를 보유하거나 판매 권한이 있는 상품만을 등록할 수 있습니다.</p>

    <p><strong>2.</strong> 셀러는 상품 등록 시 다음 사항을 정확하고 상세하게 기재하여야 합니다.</p>
    <ul>
      <li>가. 상품명, 제조사, 브랜드</li>
      <li>나. 가격, 할인율</li>
      <li>다. 상품 상세 설명</li>
      <li>라. 사이즈, 색상, 재질 등 상품 정보</li>
      <li>마. 배송 정보 (배송비, 배송기간 등)</li>
      <li>바. 교환/반품 정책</li>
      <li>사. 원산지, KC인증 등 법적 필수 표시사항</li>
    </ul>

    <p><strong>3.</strong> 다음 각 호에 해당하는 상품은 등록이 금지됩니다.</p>
    <ul>
      <li>가. 위조품, 모조품, 복제품</li>
      <li>나. 법령에 의해 판매가 금지된 상품</li>
      <li>나. 청소년 유해물품</li>
      <li>다. 음란물 또는 선정적인 상품</li>
      <li>라. 타인의 지적재산권을 침해하는 상품</li>
      <li>마. 허위·과장 광고가 포함된 상품</li>
      <li>바. 기타 공공질서 및 미풍양속에 반하는 상품</li>
    </ul>

    <h2>제5조 (콘텐츠 업로드 및 저작권)</h2>
    <p><strong>1.</strong> 셀러는 상품 판매를 촉진하기 위해 이미지, 영상(릴스), 음원 등 다양한 형태의 콘텐츠를 업로드할 수 있습니다.</p>

    <p><strong>2. 콘텐츠 업로드 시 셀러의 책임</strong></p>
    <ul>
      <li>가. 셀러가 업로드하는 모든 콘텐츠(이미지, 영상, 음원 등)에 대한 저작권, 초상권, 상표권 등 모든 권리는 셀러에게 있으며, 이에 대한 모든 법적 책임은 셀러가 부담합니다.</li>
      <li>나. 셀러는 업로드하는 콘텐츠가 제3자의 지적재산권, 초상권, 명예권 등 권리를 침해하지 않음을 보증합니다.</li>
      <li>다. 콘텐츠에 포함된 음원, 배경음악, 효과음 등에 대한 저작권 사용 허가는 셀러가 직접 확보하여야 합니다.</li>
      <li>라. 셀러는 업로드한 콘텐츠로 인해 발생하는 모든 법적 분쟁 및 손해배상에 대해 전적으로 책임을 집니다.</li>
    </ul>

    <p><strong>3. 회사의 면책</strong></p>
    <ul>
      <li>가. 회사는 셀러가 업로드한 콘텐츠의 적법성, 정확성, 진실성에 대하여 보증하지 않습니다.</li>
      <li>나. 셀러가 업로드한 콘텐츠로 인해 제3자와 분쟁이 발생한 경우, 회사는 이에 대한 책임을 지지 않습니다.</li>
      <li>다. 다만, 회사는 명백히 위법한 콘텐츠를 발견하거나 제3자의 신고가 있는 경우 해당 콘텐츠를 삭제하거나 게시 중단할 수 있습니다.</li>
    </ul>

    <p><strong>4. 콘텐츠 라이선스</strong></p>
    <ul>
      <li>가. 셀러는 업로드한 콘텐츠에 대하여 회사가 서비스 운영 목적으로 사용할 수 있도록 비독점적, 양도 가능, 재실시 가능, 전 세계적, 무상의 라이선스를 부여합니다.</li>
      <li>나. 회사는 셀러가 업로드한 콘텐츠를 다음 목적으로 사용할 수 있습니다.
        <ul>
          <li>- 플랫폼 내 상품 노출 및 추천</li>
          <li>- 마케팅 및 프로모션 활동</li>
          <li>- 서비스 개선 및 품질 향상</li>
          <li>- 통계 및 분석</li>
        </ul>
      </li>
      <li>다. 셀러가 콘텐츠를 삭제하거나 계정을 해지하는 경우, 회사는 해당 콘텐츠 사용을 중단합니다. 단, 이미 배포된 콘텐츠나 백업 시스템에 저장된 콘텐츠는 합리적인 기간 내에 삭제됩니다.</li>
    </ul>

    <p><strong>5. 금지 콘텐츠</strong></p>
    <p>다음 각 호에 해당하는 콘텐츠의 업로드는 금지되며, 위반 시 즉시 삭제 조치 및 계약 해지 사유가 될 수 있습니다.</p>
    <ul>
      <li>가. 음란물 또는 선정적인 콘텐츠</li>
      <li>나. 폭력적이거나 혐오감을 조성하는 콘텐츠</li>
      <li>다. 타인의 저작권, 초상권, 명예를 훼손하는 콘텐츠</li>
      <li>라. 허위 또는 과장된 광고 콘텐츠</li>
      <li>마. 불법 촬영물 또는 도용한 콘텐츠</li>
      <li>바. 기타 법령 또는 공공질서에 반하는 콘텐츠</li>
    </ul>

    <h2>제6조 (수수료 및 정산)</h2>
    <p><strong>1.</strong> 회사는 플랫폼 이용 및 판매 중개에 대한 수수료를 부과할 수 있으며, 수수료율은 별도로 고지합니다.</p>

    <p><strong>2.</strong> 정산은 다음과 같이 진행됩니다.</p>
    <ul>
      <li>가. 정산 주기: 월 2회 (1일~15일 / 16일~말일)</li>
      <li>나. 정산일: 익월 10일 및 25일</li>
      <li>다. 정산 금액 = 판매 금액 - 수수료 - 배송비(셀러 부담 시) - 기타 공제액</li>
      <li>라. 정산 지연 시 지연이자는 발생하지 않으나, 회사의 귀책사유로 정산이 지연된 경우에는 예외로 합니다.</li>
    </ul>

    <p><strong>3.</strong> 환불, 교환, 반품으로 인한 매출 취소 건은 정산 금액에서 차감됩니다.</p>

    <h2>제7조 (주문 처리 및 배송)</h2>
    <p><strong>1.</strong> 셀러는 주문 접수 후 지체 없이 상품을 발송하여야 하며, 특별한 사유가 없는 한 주문일로부터 3영업일 이내에 배송을 시작하여야 합니다.</p>

    <p><strong>2.</strong> 셀러는 배송 지연이 예상되는 경우 구매자에게 사전에 통지하고 양해를 구하여야 합니다.</p>

    <p><strong>3.</strong> 배송 방법, 배송비 부담, 배송 기간 등은 셀러가 상품 등록 시 명확히 표시하여야 합니다.</p>

    <h2>제8조 (교환 및 환불)</h2>
    <p><strong>1.</strong> 셀러는 전자상거래법 등 관련 법령에 따라 구매자의 교환, 환불 요청을 처리하여야 합니다.</p>

    <p><strong>2.</strong> 다음 각 호의 경우 셀러는 교환 또는 환불 요청을 즉시 수락하여야 합니다.</p>
    <ul>
      <li>가. 상품에 하자가 있는 경우</li>
      <li>나. 상품이 표시·광고와 다른 경우</li>
      <li>다. 오배송이 발생한 경우</li>
    </ul>

    <p><strong>3.</strong> 셀러의 귀책사유로 인한 교환/환불의 경우 모든 비용은 셀러가 부담합니다.</p>

    <h2>제9조 (고객 응대 및 A/S)</h2>
    <p><strong>1.</strong> 셀러는 자신이 판매한 상품에 대하여 구매자의 문의, 불만, 클레임에 성실히 응대하여야 합니다.</p>

    <p><strong>2.</strong> 셀러는 상품에 하자가 있거나 구매자에게 피해가 발생한 경우 신속하게 문제를 해결하여야 합니다.</p>

    <p><strong>3.</strong> 상품에 A/S가 필요한 경우, 셀러는 A/S 조건 및 방법을 상품 상세 페이지에 명시하여야 합니다.</p>

    <h2>제10조 (금지 행위)</h2>
    <p>셀러는 다음 각 호의 행위를 하여서는 안 됩니다.</p>
    <ol>
      <li>허위 또는 과장된 상품 정보 등록</li>
      <li>타인의 지적재산권을 침해하는 상품 판매 또는 콘텐츠 업로드</li>
      <li>불법 촬영물, 도용 콘텐츠 업로드</li>
      <li>부당한 가격 담합 또는 가격 조작</li>
      <li>리뷰 조작, 허위 주문 등 부정한 방법으로 판매 순위 조작</li>
      <li>구매자의 개인정보를 부당하게 수집하거나 유출하는 행위</li>
      <li>플랫폼 외부로 거래를 유도하는 행위</li>
      <li>회사 또는 다른 셀러의 명예를 훼손하는 행위</li>
      <li>기타 관련 법령 또는 공공질서에 반하는 행위</li>
    </ol>

    <h2>제11조 (계약의 해지)</h2>
    <p><strong>1.</strong> 셀러는 언제든지 회사에 서면 또는 전자우편으로 통지하여 계약을 해지할 수 있습니다. 단, 진행 중인 주문 건은 완료하여야 합니다.</p>

    <p><strong>2.</strong> 회사는 셀러가 다음 각 호에 해당하는 경우 사전 통지 없이 계약을 해지하거나 서비스 이용을 제한할 수 있습니다.</p>
    <ul>
      <li>가. 제10조의 금지 행위를 위반한 경우</li>
      <li>나. 허위 정보로 가입한 사실이 확인된 경우</li>
      <li>다. 타인의 저작권, 초상권 등을 침해한 경우</li>
      <li>라. 정당한 사유 없이 구매자의 주문을 반복적으로 취소하거나 배송을 지연하는 경우</li>
      <li>마. 관련 법령을 위반한 경우</li>
      <li>바. 기타 셀러로서의 의무를 현저히 위반한 경우</li>
    </ul>

    <p><strong>3.</strong> 계약 해지 시 정산되지 않은 판매 대금은 제6조에 따라 정산됩니다. 단, 셀러의 귀책사유로 계약이 해지된 경우 회사는 정산을 보류하거나 손해배상과 상계할 수 있습니다.</p>

    <h2>제12조 (손해배상)</h2>
    <p><strong>1.</strong> 셀러가 본 약관을 위반하거나 관련 법령을 위반하여 회사 또는 제3자에게 손해를 입힌 경우, 셀러는 그 손해를 배상할 책임이 있습니다.</p>

    <p><strong>2.</strong> 특히, 셀러가 업로드한 콘텐츠(이미지, 영상, 음원 등)로 인하여 제3자의 저작권, 초상권 등이 침해되어 회사가 손해배상 책임을 지게 된 경우, 셀러는 회사에 대하여 구상권을 행사할 수 있는 모든 금액을 배상하여야 합니다.</p>

    <p><strong>3.</strong> 회사가 플랫폼 운영상의 과실로 셀러에게 손해를 입힌 경우, 회사는 그 손해를 배상할 책임이 있습니다. 단, 회사가 고의 또는 중과실이 없음을 입증한 경우에는 책임이 감경될 수 있습니다.</p>

    <h2>제13조 (개인정보 보호)</h2>
    <p><strong>1.</strong> 회사는 셀러의 개인정보를 관련 법령 및 개인정보처리방침에 따라 보호합니다.</p>

    <p><strong>2.</strong> 셀러는 거래 과정에서 알게 된 구매자의 개인정보를 오직 거래 이행 목적으로만 사용하여야 하며, 이를 제3자에게 제공하거나 유출해서는 안 됩니다.</p>

    <h2>제14조 (분쟁 해결)</h2>
    <p><strong>1.</strong> 본 약관과 관련하여 분쟁이 발생한 경우, 회사와 셀러는 상호 협의하여 원만히 해결하도록 노력합니다.</p>

    <p><strong>2.</strong> 협의가 이루어지지 않는 경우, 관련 법령에 따라 중재 또는 소송을 통해 해결합니다.</p>

    <h2>제15조 (준거법 및 관할법원)</h2>
    <p><strong>1.</strong> 본 약관의 해석 및 적용에 관하여는 대한민국 법령을 준거법으로 합니다.</p>

    <p><strong>2.</strong> 회사와 셀러 간 발생한 분쟁에 관한 소송은 회사의 본사 소재지를 관할하는 법원을 전속 관할법원으로 합니다.</p>

    <h2>제16조 (약관의 변경)</h2>
    <p><strong>1.</strong> 회사는 필요한 경우 관련 법령을 위배하지 않는 범위에서 본 약관을 변경할 수 있습니다.</p>

    <p><strong>2.</strong> 약관이 변경되는 경우, 회사는 변경 내용을 시행일 7일 전부터 셀러에게 공지합니다. 단, 셀러에게 불리한 변경인 경우에는 30일 전에 공지합니다.</p>

    <p><strong>3.</strong> 셀러가 변경된 약관에 동의하지 않는 경우, 계약을 해지할 수 있습니다.</p>

    <p><strong>부칙</strong></p>

    <p><strong>제1조 (시행일)</strong><br>
    본 약관은 2025년 11월 1일부터 시행됩니다.</p>

    <p><strong>제2조 (경과조치)</strong><br>
    본 약관 시행 이전에 가입한 셀러에 대하여도 본 약관이 적용됩니다.</p>

    <hr>

    <p><strong>회사 정보</strong><br>
    상호: 클로젯<br>
    대표: 김재원<br>
    사업자등록번호: [사업자등록번호 입력 필요]<br>
    통신판매업신고번호: [통신판매업신고번호 입력 필요]<br>
    이메일: admin@clozet.my</p>

    <p>셀러 지원: admin@clozet.my<br>
    고객센터 운영시간: 평일 10:00 ~ 18:00 (주말 및 공휴일 휴무)</p>
  `;

  return (
    <TermsTemplate
      title="판매자 이용약관"
      content={content}
      lastUpdated="2025년 11월 1일"
    />
  );
}
